export default __webpack_public_path__ + "static/media/img-logo.18f9c630.png";